import { useT } from '_metronic/i18n/Metronici18n'
import { IconPaths, ModalSize } from '../../../../../../../_metronic/helpers'
import { Button, useModal } from '../../../../../../components'
import { ExameClienteModal } from '../modal/ExameClienteModal'

export const ExameClienteListToolbar = () => {
  const { showModal } = useModal()
  const { t } = useT()

  const openAddSetor = () =>
    showModal({ title: 'Exame', content: <ExameClienteModal />, size: ModalSize.Medium })

  return (
    <Button className='btn-primary' onClick={openAddSetor} icon={IconPaths.Add}>
      {t('common.add')}
    </Button>
  )
}
